export default __webpack_public_path__ + "static/media/baby6 1.742bee79.png";